SEARCH_DISCLOSURE = {
    messages: {
        VOIR_PLUS: "Voir plus",
        VOIR_MOINS: "Voir moins"
    }
};
